export default __webpack_public_path__ + "static/media/washer-active.f36c3734.png";